import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';

const Cookies = () => (
  <LegalPageTemplate title="Política de Cookies" description="Política de cookies de Nubia Solar.">
    <p>Este sitio puede utilizar cookies técnicas necesarias para el funcionamiento básico de la web y, en su caso, cookies analíticas o de terceros para mejorar la experiencia de usuario.</p>
    <h2>Qué son las cookies</h2>
    <p>Las cookies son pequeños archivos que se almacenan en tu dispositivo al visitar una página web y permiten recordar información sobre tu navegación.</p>
    <h2>Tipos de cookies</h2>
    <ul>
      <li>Cookies técnicas, necesarias para el funcionamiento del sitio.</li>
      <li>Cookies analíticas, si se habilitan herramientas de medición.</li>
      <li>Cookies de terceros, cuando se integran servicios externos como mapas o vídeos.</li>
    </ul>
    <h2>Cómo gestionarlas</h2>
    <p>Puedes eliminar o bloquear cookies desde la configuración de tu navegador. Ten en cuenta que algunas funcionalidades podrían verse afectadas.</p>
  </LegalPageTemplate>
);

export default Cookies;
